export class ComboProductDetail {
    constructor() {
        this.FixedItem = null; //Class ComboProductItem 
        this.SideChoices = [];
    }
}